/**
 * Application Domain Configuration
 *
 * This file centralizes the domain configuration for the application.
 * It uses environment variables to allow for flexibility in deployment (e.g., Vercel Preview, Staging).
 *
 * To override the default domains, set the following environment variables in your .env or Vercel dashboard:
 * - VITE_MARKETING_DOMAIN (e.g., "staging.sevenhats.com")
 * - VITE_APP_DOMAIN (e.g., "app-staging.sevenhats.com")
 */

export const DOMAINS = {
  MARKETING: import.meta.env.VITE_MARKETING_DOMAIN || 'sevenhats.com',
  APP: import.meta.env.VITE_APP_DOMAIN || 'app.sevenhats.com'
};

// Check if we are running in a preview/dev environment (not matching production domains)
const isPreview = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname !== DOMAINS.MARKETING && window.location.hostname !== DOMAINS.APP;
};

export const getMarketingUrl = (path = '') => {
  // If we are in a preview/development environment, keep navigation relative to the current origin
  // to allow testing of cross-domain flows without redirecting to production.
  if (isPreview()) {
    return `${window.location.origin}${path}`;
  }
  return `https://${DOMAINS.MARKETING}${path}`;
};

export const getAppUrl = (path = '') => {
  // If we are in a preview/development environment, keep navigation relative to the current origin
  // to allow testing of cross-domain flows without redirecting to production.
  if (isPreview()) {
    return `${window.location.origin}${path}`;
  }
  return `https://${DOMAINS.APP}${path}`;
};

export const isMarketingDomain = () => typeof window !== 'undefined' && window.location.hostname === DOMAINS.MARKETING;
export const isAppDomain = () => typeof window !== 'undefined' && window.location.hostname === DOMAINS.APP;
